module.exports = __webpack_public_path__ + "static/img/Matthew.4073ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/photos/testimonials/ats/Matthew.png
// module id = DR3K
// module chunks = 0